import { render, staticRenderFns } from "./FlatVoc.vue?vue&type=template&id=fc4d885c&scoped=true&"
import script from "./FlatVoc.vue?vue&type=script&lang=js&"
export * from "./FlatVoc.vue?vue&type=script&lang=js&"
import style0 from "./FlatVoc.vue?vue&type=style&index=0&id=fc4d885c&lang=css&scoped=true&"
import style1 from "./FlatVoc.vue?vue&type=style&index=1&id=fc4d885c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4d885c",
  null
  
)

export default component.exports